var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ChevronRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16669 5.5L7.87419 6.7925L12.0725 11L7.87419 15.2075L9.16669 16.5L14.6667 11L9.16669 5.5Z",
    fill: "#D4D5D2",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDisabled);
export default __webpack_public_path__ + "static/media/ChevronRightDisabled.87acfd7e505b091476c95db2baa155b8.svg";
export { ForwardRef as ReactComponent };